import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconDeviceMobile } from "@tabler/icons-react";
import { DispositivosDef } from "./DispositivosDef";

export const DispositivosIcon = IconDeviceMobile;
export const DispositivosHelpText = "* Contiene los dispositivos con los que opera la institución";

export class Dispositivos extends Entity<DispositivosDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new DispositivosDef(), parentKeys);
        this.Form = import('./DispositivosForm').then((module) => module.DispositivosForm);
        this.Title = 'Dispositivos';
        this.Icon = DispositivosIcon;
        this.HelpText = DispositivosHelpText;
    }
}

